/* eslint-disable react/jsx-curly-newline */
import React, { useState, useRef } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { history as historyPropTypes } from 'history-prop-types'
import { isMobile } from 'react-device-detect'
import BackButton from '../shared/BackButton'
import Loader from '../Loader/Loader.tsx'
import Modal from 'react-modal'
import userOutlineFront from '../../assets/addUserScreen/step5/user_outline_front.png'
import userOutlineSide from '../../assets/addUserScreen/step5/user_outline_side.png'
import { Link } from 'react-router-dom'
import { TopColorBar } from '../SelectSubscriptionPlanScreen/SelectSubscriptionPlanScreen'

import { usePromiseTracker } from 'react-promise-tracker'
import {
  WelcomeHeader,
  WelcomeSubHeader,
  MainScreenMainHeader,
} from '../MainScreen/MainScreen'
import addImageIcon from '../../assets/entryScreen/addImageIcon.png'
import leftArrowIcon from '../../assets/entryScreen/leftArrowIcon.png'
import rightArrowIcon from '../../assets/entryScreen/rightArrowIcon.png'
import backButtonIcon from '../../assets/entryScreen/backButtonIcon.png'
import cannotAddImageIcon from '../../assets/entryScreen/cannotAddImageIcon.png'
import deleteIcon from '../../assets/entryScreen/deleteIcon.png'
import { ScrollableImageComparisionContainer } from '../CompareScreen/CompareScreen'
import AddImage from '../AddUserScreen/AddImage'
import EndtryHeader from '../shared/EntryHeader'
import editButton from '../../assets/entryScreen/editButton.png'
import moment from 'moment'
import DemoModeAnnouncement from '../DemoModeAnnouncement/DemoModeAnnouncement.jsx'

import { fontSizeResponsive, mediaQ, manageMask } from '../theme/mixins'
import { GenericIconButton } from '../shared/DefaultStyledComponents'
import { useOutsideAlerter } from '../../utils/index'
import NavigationBar from '../shared/NavigationBar/NavigationBarContainer'
// import { url } from 'inspector'

const EntryScreenContainer = styled.div`
  width: 100%;
  scroll-behavior: smooth;
`

export const ScreenHeader = styled(MainScreenMainHeader)`
  text-align: left;
  font-family: 'Asap Condensed';
  ${fontSizeResponsive(24)}
  font-weight: bold;
  font-style: normal;
  line-height: 1.13;
  letter-spacing: normal;
  text-align: left;
  color: #fe0d9f;
  left: 25%;
  width: 50%;
  display: flex;
  justify-content: space-between;
`

const EntryScreenMainContent = styled.div`
  width: ${(props) => (props.isPhotoReadyForRemove ? '90%' : '50%')};
  margin: 0 auto 0 auto;
  padding: 20px 0;
  border-top: rgba(254, 13, 159, 0.1) 2px solid;
  border-bottom: rgba(254, 13, 159, 0.1) 2px solid;
  transition: all 0.3s ease-in-out;

  ${mediaQ('mobileAll', 'width: unset;padding: 0px 0;')}

  ${mediaQ('ipad12', 'width: unset;')}
${mediaQ('ipad10', 'width: unset;')}
${mediaQ('ipad9', 'width: unset;')}
`

export const BackbuttonIcon = styled.button`
  width: 30px;
  height: 15px;
  background: url(${backButtonIcon});
  background-size: contain;
  background-repeat: no-repeat;
  border: none;
  margin-right: 20px;
`

const Image = styled.div`
  width: ${isMobile ? '80vw' : '20vw'};
  height: 50vh;
  margin: 0 8px;
  background: ${(props) => (props.imageSrc ? `url(${props.imageSrc})` : null)}
    #efefef;
  background-size: ${(props) => (props.imageSrc ? 'contain' : '100px 100px')};
  position: relative;
  -webkit-mask-image: ${(props) =>
    props.main
      ? manageMask('main', props.imagePosition)
      : props.left
      ? manageMask('left', props.imagePosition)
      : props.right
      ? manageMask('right', props.imagePosition)
      : null};
  mask-image: ${(props) =>
    props.main
      ? manageMask('main', props.imagePosition)
      : props.left
      ? manageMask('left', props.imagePosition)
      : props.right
      ? manageMask('right', props.imagePosition)
      : null};
  box-shadow: 15px 15px 15px -14px rgba(0, 0, 0, 0.3);
  background-repeat: no-repeat;
  background-position: center;
  background-color: ${(props) => (props.imageSrc ? 'white' : 'none  ')};

  ${mediaQ('mobileAll', 'width: 80vw;')}

  ${mediaQ('mobileAll', 'width: 90%;')}

${mediaQ('ipad12', 'width: 40vw;')}
${mediaQ('ipad10', 'width: 40vw;')}
${mediaQ('ipad9', 'width: 40vw;')}
`

const ArrowButton = styled.button`
  width: 20px;
  height: 40px;
  background: ${(props) =>
    props.left ? `url(${leftArrowIcon})` : `url(${rightArrowIcon})`};
  background-size: contain;
  background-repeat: no-repeat;
  margin-right: 5px;
  position: absolute;
  left: ${(props) => (props.left ? `30%;` : 'unset')};
  right: ${(props) => (props.right ? `30%` : 'unset')};
  top: calc(50% + 30px);
  border: none;
  z-index: 2;

  ${(props) =>
    props.left
      ? mediaQ('mobileAll', 'left: 10%;')
      : mediaQ('mobileAll', 'right: 10%;')}

  ${mediaQ('mobileAll', 'top: 38%; ')};

  ${mediaQ('ipad12', 'display: none;')}
  ${mediaQ('ipad10', 'display: none;')}
${mediaQ('ipad9', 'display: none;')}
`

const InformationContainer = styled.div`
  width: 50%;
  margin: 30px auto 0 auto;
  display: flex;
  font-family: 'Asap Condensed';
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.15;
  letter-spacing: normal;
  color: #212121;

  b {
    font-weight: bold;
  }

  ${mediaQ(
    'mobileAll',
    'width: 100%; padding:0 15px; box-sizing: border-box; margin: 10px auto 0 auto;'
  )};
`

const DateInformation = styled.div`
  ${fontSizeResponsive(33)};
  width: 25%;
`

const DimensionsInformation = styled.div`
  width: 50%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  position: relative;
`

const CompareButton = styled.button`
  ${fontSizeResponsive(16)};
  padding: 5px 50px;
  height: 40px;
  margin-left: auto;
  border: none;
  background-image: linear-gradient(to right, #fe0d9f, #9e0dfe);
  color: white;
  font-family: 'Asap Condensed';
  font-weight: 500;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.15;
  letter-spacing: normal;
`

const CompareLink = styled(Link)`
  ${fontSizeResponsive(22)};
  padding: 10px 25px;
  height: 50%;
  margin-left: auto;
  border: none;
  border-radius: 3px;
  background-image: linear-gradient(to right, #fe0d9f, #9e0dfe);
  color: white;
  font-family: 'Asap Condensed';
  font-weight: 500;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.15;
  letter-spacing: normal;
  text-decoration: none;
  box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.02),
    0 6.7px 5.3px rgba(0, 0, 0, 0.028), 0 12.5px 10px rgba(0, 0, 0, 0.035),
    0 22.3px 17.9px rgba(0, 0, 0, 0.042), 0 41.8px 33.4px rgba(0, 0, 0, 0.05),
    0 100px 80px rgba(0, 0, 0, 0.07);
  transition: all 0.3s ease-in-out;

  &:hover {
    transform: scale(1.05);
  }
`

const DimensionsRow = styled.div`
  display: flex;
  width: ${(props) => (props.secondRow ? '100%' : '80%')};
  justify-content: space-evenly;
  padding: ${(props) => (props.secondRow ? '10px 0 0 0' : '0 0 10px 0')};
`

const DimensionsCol = styled.span`
  display: inline-block;
  color: ${(props) => (props.black ? '#212121' : '#fe0d9f')};
  font-size: ${(props) =>
    props.black ? fontSizeResponsive(24) : fontSizeResponsive(27)};
`

const ImagesContainer = styled.div`
  display: flex;

  ${isMobile && `width: 300vw`};
`

const EditImagesButton = styled.button`
  position: absolute;
  z-index: 0;
  width: 50px;
  height: 50px;
  background: url(${editButton});
  background-size: 60%;
  background-position: center;
  background-repeat: no-repeat;
  border: none;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  padding: 10px;
  box-shadow: 0 1.7px 2.2px -7px rgba(0, 0, 0, 0.02),
    0 4.1px 5.3px -7px rgba(0, 0, 0, 0.028),
    0 7.6px 10px -7px rgba(0, 0, 0, 0.035),
    0 13.6px 17.9px -7px rgba(0, 0, 0, 0.042),
    0 25.5px 33.4px -7px rgba(0, 0, 0, 0.05),
    0 61px 80px -7px rgba(0, 0, 0, 0.07);
  cursor: pointer;

  left: ${(props) => (props.editDimensions ? '0' : 'unset')};
  top: ${(props) => (props.editDimensions ? '-20px' : 'unset')};
`
const AgreeButton = styled.button`
  background-color: #bb2124;
  padding: 10px 40px;
  border: none;
  border-radius: 5px;
  color: white;

  font-family: 'Asap Condensed';
  font-weight: 600;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.15;
  ${fontSizeResponsive(30)};
  box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.02),
    0 6.7px 5.3px rgba(0, 0, 0, 0.028), 0 12.5px 10px rgba(0, 0, 0, 0.035),
    0 22.3px 17.9px rgba(0, 0, 0, 0.042), 0 41.8px 33.4px rgba(0, 0, 0, 0.05),
    0 100px 80px rgba(0, 0, 0, 0.07);
  margin: 10px 15px;
  cursor: pointer;
`

const CancelButton = styled.button`
  background-color: rgba(0, 0, 0, 0.05);
  opacity: 0.6;
  padding: 10px 40px;
  border: none;
  border-radius: 5px;
  color: rgba(0, 0, 0, 0.8);

  font-family: 'Asap Condensed';
  font-weight: 600;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.15;
  ${fontSizeResponsive(30)};
  box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.02),
    0 6.7px 5.3px rgba(0, 0, 0, 0.028), 0 12.5px 10px rgba(0, 0, 0, 0.035),
    0 22.3px 17.9px rgba(0, 0, 0, 0.042), 0 41.8px 33.4px rgba(0, 0, 0, 0.05),
    0 100px 80px rgba(0, 0, 0, 0.07);
  margin: 10px 15px;
  cursor: pointer;
`
const ModalButtonsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`
const ModalSpan = styled.div`
  font-family: 'Asap Condensed';
  font-weight: 500;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.15;
  -webkit-letter-spacing: normal;
  -moz-letter-spacing: normal;
  -ms-letter-spacing: normal;
  letter-spacing: normal;
  color: #212121;
  ${fontSizeResponsive(25)};
  width: 100%;
  text-align: center;
`
const ModalHeader = styled.h2`
  font-family: 'Asap Condensed';
  font-weight: bold;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.15;
  -webkit-letter-spacing: normal;
  -moz-letter-spacing: normal;
  -ms-letter-spacing: normal;
  letter-spacing: normal;
  color: #fe0d9f;
  ${fontSizeResponsive(45)};
  margin-bottom: 10px;
  width: 100%;
  text-align: center;
`
const ModalImageContainer = styled.div`
  width: 100%;
  height: 500px;

  /* background: ${(props) =>
    props.side == 'front' || props.side == 'back'
      ? `url(${userOutlineFront})`
      : `url(${userOutlineSide})`}; */

  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  ${mediaQ('mobileAll', 'height:250px;')};
`

/* prettier-ignore */ const ScrollableImageEntryContainer = styled(ScrollableImageComparisionContainer)`
  width: ${(props) => (props.isPhotoReadyForRemove ? '70%' : '45%')};
  margin-left: ${(props) => (props.isPhotoReadyForRemove ? '15%' : '25%')};
  justify-content: ${(props) => props.isPhotoReadyForRemove ? 'center' : 'unset'};
  -webkit-mask-image: ${(props) =>
    props.imagePosition === 'right'
      ? `linear-gradient(
    90deg,
    rgba(239, 239, 239, 0) -2%,
    rgba(255, 255, 255, 1) 8%,
    rgba(255, 255, 255, 1) 95%,
    rgba(239, 239, 239, 0) 106%
  )`
      : `linear-gradient(
    90deg,
    rgba(239, 239, 239, 0) -2%,
    rgba(255, 255, 255, 1) 8%,
    rgba(255, 255, 255, 1) 95%,
    rgba(239, 239, 239, 0) 101%
  )`};
  mask-image: ${(props) =>
    props.imagePosition === 'right'
      ? `linear-gradient(
    90deg,
    rgba(239, 239, 239, 0) -2%,
    rgba(255, 255, 255, 1) 8%,
    rgba(255, 255, 255, 1) 95%,
    rgba(239, 239, 239, 0) 106%
  )`
      : `linear-gradient(
    90deg,
    rgba(239, 239, 239, 0) -2%,
    rgba(255, 255, 255, 1) 8%,
    rgba(255, 255, 255, 1) 95%,
    rgba(239, 239, 239, 0) 101%
  )`};

  ${mediaQ('mobileAll', 'margin-left:5%;width:80%')}

  ${mediaQ('ipad12', 'margin-left:10%;width:80%')}
${mediaQ('ipad10', 'margin-left:10%;width:80%')}
${mediaQ(
  'ipad9',
  'margin-left:10%;width:80%'
)}
`

const RemoveAgreeButton = styled.button`
  background-color: #bb2124;
  padding: 10px 40px;
  border: none;
  border-radius: 5px;
  color: white;

  font-family: 'Asap Condensed';
  font-weight: 600;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.15;
  ${fontSizeResponsive(30)};
  box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.02),
    0 6.7px 5.3px rgba(0, 0, 0, 0.028), 0 12.5px 10px rgba(0, 0, 0, 0.035),
    0 22.3px 17.9px rgba(0, 0, 0, 0.042), 0 41.8px 33.4px rgba(0, 0, 0, 0.05),
    0 100px 80px rgba(0, 0, 0, 0.07);
  margin: 10px 15px;
  cursor: pointer;
`

const RemoveCancelButton = styled.button`
  background-color: rgba(0, 0, 0, 0.05);
  opacity: 0.6;
  padding: 10px 40px;
  border: none;
  border-radius: 5px;
  color: rgba(0, 0, 0, 0.8);

  font-family: 'Asap Condensed';
  font-weight: 600;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.15;
  ${fontSizeResponsive(30)};
  box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.02),
    0 6.7px 5.3px rgba(0, 0, 0, 0.028), 0 12.5px 10px rgba(0, 0, 0, 0.035),
    0 22.3px 17.9px rgba(0, 0, 0, 0.042), 0 41.8px 33.4px rgba(0, 0, 0, 0.05),
    0 100px 80px rgba(0, 0, 0, 0.07);
  margin: 10px 15px;
  cursor: pointer;
`
const RemoveModalButtonsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 30px;
`
const RemoveModalHeader = styled.h2`
  font-family: 'Asap Condensed';
  font-weight: bold;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.15;
  -webkit-letter-spacing: normal;
  -moz-letter-spacing: normal;
  -ms-letter-spacing: normal;
  letter-spacing: normal;
  color: #fe0d9f;
  ${fontSizeResponsive(45)};
  width: 100%;
  text-align: center;
`

const EditDimensionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 30px 0;
`
const EditDimensionsInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
  position: relative;
`
const EditDimensionsInputLabel = styled.span`
  width: 100%;
  text-align: center;
  font-family: 'Asap Condensed';
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.15;
  -webkit-letter-spacing: normal;
  -moz-letter-spacing: normal;
  -ms-letter-spacing: normal;
  letter-spacing: normal;
  color: #212121;
  ${fontSizeResponsive(22)};
  width: 100%;
  text-align: center;
`
const EditDimensionsMetric = styled.div`
  position: absolute;
  bottom: 8px;
  ${fontSizeResponsive(22)};
  font-family: 'Asap Condensed';
  font-stretch: condensed;
  font-style: normal;
  font-weight: 300;
  line-height: 1.15;
  -webkit-letter-spacing: normal;
  -moz-letter-spacing: normal;
  -ms-letter-spacing: normal;
  -webkit-letter-spacing: normal;
  -moz-letter-spacing: normal;
  -ms-letter-spacing: normal;
  letter-spacing: normal;
  color: #212121;
  width: 50%;
  text-align: end;
`
const EditDimensionsInput = styled.input`
  width: 50%;
  margin: 5px 0;
  border: none;
  border-bottom: 1px solid #fe0d9f;
  text-align: center;
`
const EditDimensionsButtonSave = styled.button`
  background: linear-gradient(
    90deg,
    rgba(254, 13, 160, 1) 0%,
    rgba(250, 174, 1, 1) 100%
  );

  border: none;
  border-radius: 4px;
  padding: 15px 55px;
  font-family: 'Asap Condensed';
  text-align: center;
  font-weight: 600;
  color: white;
  ${fontSizeResponsive(30)};
  box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.02),
    0 6.7px 5.3px rgba(0, 0, 0, 0.028), 0 12.5px 10px rgba(0, 0, 0, 0.035),
    0 22.3px 17.9px rgba(0, 0, 0, 0.042), 0 41.8px 33.4px rgba(0, 0, 0, 0.05),
    0 100px 80px rgba(0, 0, 0, 0.07);
  margin: 10px 15px;
  cursor: pointer;
`

const extractDate = (entry) => {
  const splittedDate = entry && entry.creation_datetime.split('-')

  const dateObj = {
    year: splittedDate[0],
    month: splittedDate[1],
    day: splittedDate[2],
  }

  return dateObj
}

const EntryScreen = ({
  openMenu,
  onOpenMenuClick,
  onSubpageChange,
  isPlayerActive,
  changeLocation,
  closeMenu,

  goBack,
  history,
  changeDefaultBackground,
  onImageSave,
  userFrontPhoto,
  resetBackground,
  userBackPhoto,
  userSidePhoto,
  scrollImages,
  stateImagePosition,
  checkIsToday,
  onNotCurrentDayAddImageError,
  isPhotoReadyForRemove,
  enterRemoveImagesMode,
  exitRemoveImagesMode,
  removeImage,
  onChangeHandler,
  testFile,
  currentFeed,
  userFrontBackground,
  userSideBackground,
  userBackBackground,
  isThisTodaysEntry,
  isAgreementButtonsOn,
  saveOriginalImages,
  resetImage,
  isLoading,
  enterEditEntry,
  isEditEntry,
  editImage,
  isEditImageModalOpen,
  closeEditImagesModal,
  openEditImagesModal,
  currentEditingSide,
  saveEditTempImages,
  onEditImageSave,
  editTempUserFrontPhoto,
  editTempUserBackPhoto,
  editTempUserSidePhoto,
  getImageId,
  photos,
  isRemoveEntryModalOpen,
  closeRemoveEntryModal,
  openRemoveEntryModal,
  onRemoveEntry,
  tempUserFrontBackground,
  tempUserSideBackground,
  tempUserBackBackground,
  isThereTempImage,
  showCompareButton,
  earliestFeedId,
  currentFeedId,
  isEditDimensionsModalOpen,
  openEditDimensionsModal,
  closeEditDimensionsModal,
  saveEditDimensions,
  storeEdittedDimension,
  isDemoAccount,
  user,
}) => {
  const wrapperRef = useRef(null)
  const { promiseInProgress } = usePromiseTracker()

  Modal.setAppElement('#root')
  const date = currentFeed && extractDate(currentFeed)

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      zIndex: '1222',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  }

  const selectProperEditPhoto = () => {
    let propertempbackground
    switch (currentEditingSide) {
      case 'front':
        propertempbackground = editTempUserFrontPhoto
        return propertempbackground
      case 'back':
        propertempbackground = editTempUserBackPhoto
        return propertempbackground
      case 'side':
        propertempbackground = editTempUserSidePhoto
        return propertempbackground
      default:
        break
    }
    return currentEditingSide
  }

  useOutsideAlerter(wrapperRef, useState, exitRemoveImagesMode)

  const formatMonthName = (monthNumber) => {
    switch (monthNumber) {
      case '01':
        return ' stycznia'
      case '02':
        return ' lutego'
      case '03':
        return ' marca'
      case '04':
        return ' kwietnia'
      case '05':
        return ' maja'
      case '06':
        return ' czerwca'
      case '07':
        return ' lipca'
      case '08':
        return ' sierpnia'
      case '09':
        return ' września'
      case '10':
        return ' października'
      case '11':
        return ' listopada'
      case '12':
        return ' grudnia'
      default:
        break
    }
  }

  const isEditable = (entry, side) => {
    let editable = false
    const dateToday = new Date()
    const formattedDate = moment(dateToday).format('YYYY-MM-DD')

    if (
      entry &&
      moment(entry.creation_datetime).format('YYYY-MM-DD') == formattedDate
    ) {
      // switch (side) {
      //   case 'front':
      //     if (userFrontBackground == null || tempUserFrontBackground == null) {
      //       editable = true
      //     }
      //     return editable
      //   case 'side':
      //     if (userSideBackground == null || tempUserSideBackground == null) {
      //       editable = true
      //     }
      //   case 'back':
      //     if (userBackBackground == null || tempUserBackBackground == null) {
      //       editable = true
      //     }
      //     return editable

      editable = true
      return editable
    }
    return editable
  }

  return (
    <EntryScreenContainer>
      <TopColorBar relative>
        <BackButton
          place={`Wpis z dnia  ${currentFeed && currentFeed.creation_datetime}`}
          specialLocation={'/trening'}
          isActive={true}
        />
      </TopColorBar>
      <NavigationBar />

      <EndtryHeader
        goBack={goBack}
        entry={currentFeed}
        headerParent="EntryScreen"
        enterRemoveImagesMode={enterRemoveImagesMode}
        isThisTodaysEntry={isThisTodaysEntry}
        enterEditEntry={enterEditEntry}
        isEditEntry={isEditEntry}
        openRemoveEntryModal={openRemoveEntryModal}
      />
      <EntryScreenMainContent
        isPhotoReadyForRemove={isPhotoReadyForRemove}
        ref={wrapperRef}
      >
        {stateImagePosition !== 'left' && !isPhotoReadyForRemove && (
          <ArrowButton left onClick={() => scrollImages('left')} />
        )}
        <ScrollableImageEntryContainer
          horizontal={false}
          vertical={false}
          imagePosition={stateImagePosition}
          isPhotoReadyForRemove={isPhotoReadyForRemove}
        >
          <ImagesContainer ref={wrapperRef}>
            <Image
              isTodaysEntry={currentFeed && isThisTodaysEntry(currentFeed)}
              imageSrc={
                tempUserSideBackground
                  ? tempUserSideBackground
                  : userSideBackground
                  ? userSideBackground
                  : null
              }
              className={'tutaj-zdiecia'}
            >
              {isEditEntry && (
                <EditImagesButton onClick={() => editImage('side')} />
              )}
              {isPhotoReadyForRemove && (
                <GenericIconButton
                  backgroundUrl={deleteIcon}
                  width="30px"
                  height="30px"
                  position="absolute"
                  right="-5px"
                  top="-5px"
                  data-tag="side"
                  onClick={(e) => removeImage(e)}
                />
              )}
              {stateImagePosition === 'left' &&
              !isMobile &&
              isThisTodaysEntry(currentFeed) ? (
                <AddImage
                  changeDefaultBackground={changeDefaultBackground}
                  onImageSave={onImageSave}
                  side="side"
                  // imageUrl={userSidePhoto}
                  class
                  isEditable={isEditable(currentFeed, 'side')}
                  resetBackground={resetBackground}
                  onChangeHandler={onChangeHandler}
                  background={
                    tempUserSideBackground
                      ? tempUserSideBackground
                      : userSideBackground
                      ? userSideBackground
                      : null
                  }
                  isAgreementButtonsOn={isAgreementButtonsOn}
                  saveOriginalImages={saveOriginalImages}
                  resetImage={resetImage}
                  absolutePosition
                  isThereTempImage={isThereTempImage('side')}
                />
              ) : null}
            </Image>
            <Image
              imageSrc={
                tempUserFrontBackground
                  ? tempUserFrontBackground
                  : userFrontBackground
                  ? userFrontBackground
                  : null
              }
              isTodaysEntry={currentFeed && isThisTodaysEntry(currentFeed)}
            >
              {isEditEntry && (
                <EditImagesButton onClick={() => editImage('front')} />
              )}
              {isPhotoReadyForRemove && (
                <GenericIconButton
                  backgroundUrl={deleteIcon}
                  width="30px"
                  height="30px"
                  position="absolute"
                  right="-5px"
                  top="-5px"
                  data-tag="front"
                  onClick={(e) => removeImage(e)}
                />
              )}

              {!isMobile && true ? (
                <AddImage
                  changeDefaultBackground={changeDefaultBackground}
                  onImageSave={onImageSave}
                  side="front"
                  isEditable={isEditable(currentFeed, 'front')}
                  // imageUrl={userFrontPhoto}
                  resetBackground={resetBackground}
                  onChangeHandler={onChangeHandler}
                  background={
                    tempUserFrontBackground
                      ? tempUserFrontBackground
                      : userFrontBackground
                      ? userFrontBackground
                      : null
                  }
                  isAgreementButtonsOn={isAgreementButtonsOn}
                  saveOriginalImages={saveOriginalImages}
                  resetImage={resetImage}
                  absolutePosition
                  isThereTempImage={isThereTempImage('front')}
                />
              ) : null}
            </Image>
            <Image
              imageSrc={
                tempUserBackBackground
                  ? tempUserBackBackground
                  : userBackBackground
                  ? userBackBackground
                  : null
              }
              isTodaysEntry={isThisTodaysEntry(currentFeed)}
            >
              {isEditEntry && (
                <EditImagesButton onClick={() => editImage('front')} />
              )}

              {stateImagePosition === 'right' &&
              isThisTodaysEntry(currentFeed) &&
              !isMobile ? (
                <AddImage
                  isEditable={isEditable(currentFeed, 'back')}
                  changeDefaultBackground={changeDefaultBackground}
                  onImageSave={onImageSave}
                  side="back"
                  absolutePosition
                  // imageUrl={userBackPhoto}
                  resetBackground={resetBackground}
                  onChangeHandler={onChangeHandler}
                  background={
                    tempUserBackBackground
                      ? tempUserBackBackground
                      : userBackBackground
                      ? userBackBackground
                      : null
                  }
                  isAgreementButtonsOn={isAgreementButtonsOn}
                  saveOriginalImages={saveOriginalImages}
                  resetImage={resetImage}
                  isThereTempImage={isThereTempImage('back')}
                />
              ) : null}
            </Image>
          </ImagesContainer>
        </ScrollableImageEntryContainer>
        {stateImagePosition !== 'right' && !isPhotoReadyForRemove && (
          <ArrowButton right onClick={() => scrollImages('right')} />
        )}
      </EntryScreenMainContent>

      <InformationContainer>
        <DateInformation>
          <b>
            {date && date.day} {formatMonthName(date && date.month)}
          </b>{' '}
          {date && date.year}
        </DateInformation>
        <DimensionsInformation>
          {isEditEntry && (
            <EditImagesButton
              onClick={openEditDimensionsModal}
              editDimensions
            />
          )}
          <DimensionsRow>
            <DimensionsCol>
              <b>{currentFeed && currentFeed.belly_circumference}</b>
            </DimensionsCol>
            <DimensionsCol>/</DimensionsCol>
            <DimensionsCol>
              <b>{currentFeed && currentFeed.hip_circumference}</b>
            </DimensionsCol>
            <DimensionsCol>/</DimensionsCol>
            <DimensionsCol>
              <b>{currentFeed && currentFeed.thigh_circumference}</b>
            </DimensionsCol>
          </DimensionsRow>
          <DimensionsRow secondRow>
            <DimensionsCol black>Brzuch</DimensionsCol>
            <DimensionsCol black>Biodra</DimensionsCol>
            <DimensionsCol black>Udo</DimensionsCol>
          </DimensionsRow>
        </DimensionsInformation>
        {showCompareButton && (
          <CompareLink
            to={`/postepy/porownaj/${currentFeedId}-${earliestFeedId}`}
          >
            Porównaj
          </CompareLink>
        )}
      </InformationContainer>

      <Modal
        isOpen={isEditImageModalOpen}
        // onAfterOpen={afterOpenModal}
        onRequestClose={closeEditImagesModal}
        style={customStyles}
      >
        <ModalHeader>Edytuj obecne zdjęcie</ModalHeader>
        <ModalSpan>
          Wybierz nowe zdjęcie. Obecne zdjęcie zostanie nim zastąpione.
        </ModalSpan>
        <ModalImageContainer side={currentEditingSide}>
          <AddImage
            changeDefaultBackground={changeDefaultBackground}
            onImageSave={onEditImageSave}
            side={currentEditingSide}
            absolutePosition
            isEditable={isEditEntry}
            // imageUrl={selectProperEditPhoto()}
            resetBackground={resetBackground}
            onChangeHandler={onChangeHandler}
            background={selectProperEditPhoto()}
            isAgreementButtonsOn={isAgreementButtonsOn}
            saveOriginalImages={saveOriginalImages}
            resetImage={resetImage}
            isEditMode={true}
            photoId={getImageId(currentEditingSide, photos)}
            isThereTempImage={isThereTempImage('front')}
          />
        </ModalImageContainer>
      </Modal>
      <Modal
        isOpen={isEditDimensionsModalOpen}
        // onAfterOpen={afterOpenModal}
        onRequestClose={closeEditDimensionsModal}
        style={customStyles}
      >
        <ModalHeader>Edytuj wymiary wpisu</ModalHeader>
        <ModalSpan>Podaj nowe pomiary poniżej by zamienić obecne</ModalSpan>
        <EditDimensionsContainer>
          <EditDimensionsInputContainer>
            <EditDimensionsInputLabel>Obwód brzucha: </EditDimensionsInputLabel>
            <EditDimensionsInput
              onChange={(e) => storeEdittedDimension('belly', e)}
              type="number"
              min="0"
            />
          </EditDimensionsInputContainer>
          <EditDimensionsInputContainer>
            <EditDimensionsInputLabel>Obwód bioder: </EditDimensionsInputLabel>
            <EditDimensionsInput
              onChange={(e) => storeEdittedDimension('hip', e)}
              type="number"
              min="0"
            />
          </EditDimensionsInputContainer>
          <EditDimensionsInputContainer>
            <EditDimensionsInputLabel>Obwód uda: </EditDimensionsInputLabel>
            <EditDimensionsInput
              onChange={(e) => storeEdittedDimension('thigh', e)}
              type="number"
              min="0"
            />
          </EditDimensionsInputContainer>
        </EditDimensionsContainer>
        <EditDimensionsButtonSave onClick={saveEditDimensions}>
          Zapisz nowe pomiary
        </EditDimensionsButtonSave>
      </Modal>
      <Modal
        isOpen={isRemoveEntryModalOpen}
        // onAfterOpen={afterOpenModal}
        onRequestClose={closeRemoveEntryModal}
        style={customStyles}
      >
        <RemoveModalHeader>Usuń wpis</RemoveModalHeader>
        <ModalSpan>Czy jesteś pewna, że chcesz usunąć ten wpis?</ModalSpan>
        <RemoveModalButtonsContainer>
          <RemoveAgreeButton onClick={onRemoveEntry}>Tak</RemoveAgreeButton>
          <RemoveCancelButton onClick={closeRemoveEntryModal}>
            Anuluj
          </RemoveCancelButton>
        </RemoveModalButtonsContainer>
      </Modal>
      {isDemoAccount && <DemoModeAnnouncement />}
      {promiseInProgress && <Loader />}
    </EntryScreenContainer>
  )
}

// EntryScreen.propTypes = {
//   openMenu: PropTypes.bool.isRequired,
//   onSubpageChange: PropTypes.func.isRequired,
//   onOpenMenuClick: PropTypes.func.isRequired,
//   isPlayerActive: PropTypes.bool,
//   changeLocation: PropTypes.func.isRequired,
//   closeMenu: PropTypes.func.isRequired,
//   entry: PropTypes.objectOf(PropTypes.any).isRequired,
//   history: PropTypes.shape(historyPropTypes),
//   goBack: PropTypes.func.isRequired,
//   changeDefaultBackground: PropTypes.func.isRequired,
//   onImageSave: PropTypes.func.isRequired,
//   userFrontPhoto: PropTypes.objectOf(PropTypes.any).isRequired,
//   userBackPhoto: PropTypes.objectOf(PropTypes.any).isRequired,
//   userSidePhoto: PropTypes.objectOf(PropTypes.any).isRequired,
//   resetBackground: PropTypes.func.isRequired,
//   scrollImages: PropTypes.func.isRequired,
//   stateImagePosition: PropTypes.string.isRequired,
//   checkIsToday: PropTypes.func.isRequired,
//   onNotCurrentDayAddImageError: PropTypes.func.isRequired,
//   isPhotoReadyForRemove: PropTypes.bool.isRequired,
//   enterRemoveImagesMode: PropTypes.func.isRequired,
//   exitRemoveImagesMode: PropTypes.func.isRequired,
//   removeImage: PropTypes.func.isRequired,
// }

EntryScreen.defaultProps = {
  isPlayerActive: false,
  history: PropTypes.shape(historyPropTypes),
}
export default EntryScreen
